import { render, staticRenderFns } from "./GenderDisplayText.vue?vue&type=template&id=da4eb81c&scoped=true&"
import script from "./GenderDisplayText.vue?vue&type=script&lang=js&"
export * from "./GenderDisplayText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4eb81c",
  null
  
)

export default component.exports